import React from "react"
import { Cell } from "fixed-data-table-2"
import { patchColumnData, toggleSelectOpen } from "sheets/sheet-action-creators"
import { connect } from "react-redux"
import { StafferSelect } from "selects/containers/PieSelect"
import classNames from "classnames"
import PropTypes from "prop-types"

export const StafferSelectCell =
    ({ children, sheetId, rowId, columnId, editing, isPublicSheet, ...props }) =>
        <div
            className={classNames(
                { "staffer-select-cell": !isPublicSheet },
                { editing, chosen: children && children.get("chosen") }
            )}
        >
            <Cell {...props}>
                { editing && !isPublicSheet
                ? <StafferSelect
                    autoFocus
                    id={`${sheetId}:${rowId}:${columnId}`}
                    permanentFilter={{
                        person: rowId
                    }}
                    onChange={({ person, ...staffer }) =>
                        props.patchColumnData({
                            id: sheetId,
                            columnId,
                            rowId,
                            newValue: { person: rowId, ...staffer, chosen: true }
                        })
                    }
                    value={children && children.get("id")}
                    clearable={false}
                    autoload={false || editing}
                    searchify={false}
                    onOpen={() => { props.toggleSelectOpen(sheetId, true) }}
                    onClose={() => { props.toggleSelectOpen(sheetId, false) }}

                />
                : (children && children.get("name"))
            }
            </Cell>
        </div>

StafferSelectCell.propTypes = {
    children: PropTypes.object.isRequired,
    patchColumnData: PropTypes.func.isRequired,
    rowId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    columnId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    toggleSelectOpen: PropTypes.func.isRequired,
    sheetId: PropTypes.string.isRequired,
    isPublicSheet: PropTypes.bool,
    editing: PropTypes.bool.isRequired,
}

StafferSelectCell.defaultProps = {
    isPublicSheet: false,
}

export default connect(null, { patchColumnData, toggleSelectOpen })(StafferSelectCell)
